(function(){

  var loadScript = function(url, callback){
 
    var script = document.createElement("script")
    script.type = "text/javascript";
 
    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }
 
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);

  };

  var myAppJavaScript = function($){
    
    
    /* CUSTOM JAVASCRIPT CODE BEGINS HERE ----------------------------------------------------------- */
    
    
    /* Disable the links in the navigation that aren't linked to anything --------------------------- */
    $('.Header__MainNav a[href="#"]').click(function(e) {
      e.preventDefault();
    });
    

    /* Find the Google Map link in the footer and make it a map ------------------------------------- */
    $('#section-footer .Footer__Content.Rte a').each(function() {
      if($(this).html() === 'View Google Map') {
		$(this).addClass('dondrumm_map').attr('target','_blank');
      }
    });
    
    $('#triad_collection_menu > li > a').click(function(e) {
      e.preventDefault();
      var $parent = $(this).parent();
      if ($parent.hasClass('open')) {
        $parent.removeClass('open');
      } else {
		$parent.addClass('open'); 
      }
        
    });
    
    
    /* CUSTOM JAVASCRIPT CODE ENDS HERE ------------------------------------------------------------- */
    
    
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
      jQuery191 = jQuery.noConflict(true);
      myAppJavaScript(jQuery191);
    });
  } else {
    myAppJavaScript(jQuery);
  }
  
})();